import React from "react";
import { DEFAULT_AVATAR, getResponsiveImageProps } from "@/shared/utils/responsiveImage";

export interface ResponsiveAvatarProps
	extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src" | "width" | "height"> {
	src?: string | null;
	displaySize: number;
	fallback?: string;
}

export const ResponsiveAvatar = React.forwardRef<HTMLImageElement, ResponsiveAvatarProps>(
	({ src, displaySize, fallback = DEFAULT_AVATAR, onError, alt = "", ...rest }, ref) => {
		const imageProps = getResponsiveImageProps(src, displaySize, fallback);

		return (
			<img
				ref={ref}
				{...rest}
				src={imageProps.src}
				srcSet={imageProps.srcSet}
				width={imageProps.width}
				height={imageProps.height}
				alt={alt}
				onError={(e) => {
					const target = e.currentTarget;
					if (target.src.endsWith(fallback)) return;
					target.removeAttribute("srcset");
					target.src = fallback;
					onError?.(e);
				}}
			/>
		);
	},
);

ResponsiveAvatar.displayName = "ResponsiveAvatar";
